import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// render - login
const AcceptInvitation = Loadable(lazy(() => import('pages/authentication/AcceptInvitation')));

// ==============================|| BASIC ROUTING ||============================== //

const BasicRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: 'accept-invitation',
      element: <AcceptInvitation />
    }
  ]
};

export default BasicRoutes;
